import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatisticsQueryService } from '@app/core';
import { SectionHeaderComponent, TimeAgoPipe } from '@app/widgets';
import { TuiAppearance, TuiIcon } from '@taiga-ui/core';
import { TuiPulse } from '@taiga-ui/kit';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'app-native-builds-statistics-section',
  imports: [
    CountUpModule,
    SectionHeaderComponent,
    TimeAgoPipe,
    TuiAppearance,
    TuiIcon,
    TuiPulse,
  ],
  templateUrl: './native-builds-statistics-section.component.html',
  styleUrl: './native-builds-statistics-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsStatisticsSectionComponent {
  protected readonly statistics = this.statisticsQueryService.queryStatistics();

  constructor(
    private readonly statisticsQueryService: StatisticsQueryService,
  ) {}
}
